export enum SmartSearchPageEnum {
  BuyingProcessStage = 'BuyingProcessStage',
  BasicDetails = 'BasicDetails',
  InitialRate = 'InitialRate',
  LiveResults = 'LiveResults',
}
